import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseDataDto } from '../shared/types/courseDataDto';
import { OeAppService } from './oe-app.service';

@Injectable({
  providedIn: 'root',
})
export class CourseDataService {
  constructor(private httpClient: HttpClient, private oeAppService: OeAppService) {}

  getCourseData(courseId: number): Observable<CourseDataDto> {
    const url = `${this.oeAppService.courseServiceHost}/v1/courses/${courseId}`;
    return this.httpClient.get<CourseDataDto>(url);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/course-data.service.ts